import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import Lenis from "lenis";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import MailClub from "@/pages/MailClub";
import ReadingRoom from "@/pages/ReadingRoom";
import About from "@/pages/About";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import ShareYourStory from "@/pages/ShareYourStory";
import ManagePlan from "@/pages/ManagePlan";
import Admin from "@/pages/Admin";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";
import TermsAndConditions from "@/pages/legal/TermsAndConditions";
import FirstEnvelope from "@/pages/FirstEnvelope";
import {
  ColourMeMamaLanding,
  ColourMeMamaQuiz,
  ColourMeMamaFinding,
  ColourMeMamaResult,
  ColourMeMamaShare,
  ColourMeMamaMeet,
} from "@/pages/ColourMeMama";
import "@/App.css";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function LenisProvider() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.35,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      lerp: 0.09,
    });
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);
    return () => lenis.destroy();
  }, []);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <LenisProvider />
      <ScrollToTop />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/mail-club" element={<MailClub />} />
          <Route path="/subscribe" element={<MailClub />} />
          <Route path="/pregnancy-edition" element={<Navigate to="/mail-club?edition=pregnancy" replace />} />
          <Route path="/motherhood-edition" element={<Navigate to="/mail-club?edition=motherhood" replace />} />
          <Route path="/reading-room" element={<ReadingRoom />} />
          <Route path="/about" element={<About />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/share-your-story" element={<ShareYourStory />} />
          <Route path="/manage" element={<ManagePlan />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/colour-me-mama" element={<ColourMeMamaLanding />} />
          <Route path="/colour-me-mama/quiz/:index" element={<ColourMeMamaQuiz />} />
          <Route path="/colour-me-mama/finding" element={<ColourMeMamaFinding />} />
          <Route path="/colour-me-mama/result" element={<ColourMeMamaResult />} />
          <Route path="/colour-me-mama/share" element={<ColourMeMamaShare />} />
          <Route path="/colour-me-mama/meet" element={<ColourMeMamaMeet />} />
          <Route path="/first-envelope" element={<FirstEnvelope />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
